import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { css, styled } from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from '@design-system/box';
import { Divider } from '@design-system/divider';
import { NavLinkSimple } from '@design-system/link';
import { TAB_FONTS, TAB_UNDERLINE_SIZES, TAB_UNDERLINE_SPACING_SIZES, } from './constants';
import { DotNotification } from './DotNotification';
export const Tab = ({ active = false, dataTestId = 'ds-tab', disabled = false, dot = false, label, onClickAction, path, size = 'normal', underlineSpacingSize = TAB_UNDERLINE_SIZES.NORMAL, }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { fontName, variantName } = TAB_FONTS[size];
    const underlineSpacingSizeValue = TAB_UNDERLINE_SPACING_SIZES[underlineSpacingSize];
    const font = active ? variantName : fontName;
    return (_jsxs(TabContainer, { "$disabled": disabled, "data-testid": `${dataTestId}-container`, font: font, children: [dot && _jsx(DotNotification, { "data-testid": `${dataTestId}-dot` }), path ? (_jsx(TabLink, { onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), tabIndex: 0, to: path, children: label })) : (_jsx(TabButton, { "aria-pressed": active, "data-testid": `${dataTestId}-button`, onClick: onClickAction, onKeyDown: onClickAction && onEnterOrSpacePress(onClickAction), onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), role: "button", tabIndex: 0, children: label })), (active || isHovered) && (_jsx(TabUnderline, { "$underlineSpacing": underlineSpacingSizeValue, borderBottomColor: "primary", borderBottomStyle: "solid", borderBottomWidth: "4px", "data-testid": `${dataTestId}-underline` }))] }));
};
const TabUnderline = styled(Divider).attrs(({ $underlineSpacing }) => ({
    mb: 0,
    mt: $underlineSpacing,
})) ``;
const disabledVariant = ({ $disabled }) => {
    if (!$disabled) {
        return css ``;
    }
    return css `
    cursor: default;
    pointer-events: none;
    opacity: 40%;
  `;
};
const TabContainer = styled(Box).attrs({
    flexDirection: 'column',
    position: 'relative',
}) `
  ${TabUnderline} {
    border-radius: ${({ theme }) => theme.themeVariables.globalBorderRadius}px;
  }

  ${disabledVariant}
`;
const TabLink = styled(NavLinkSimple) `
  color: ${({ theme }) => theme.colors.asphalt};
`;
const TabButton = styled(Box) `
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  cursor: pointer;
`;
//# sourceMappingURL=Tab.js.map